import classNames from "classnames";
import { styled } from "@mui/material";

interface ILoadingMessageProps {
  message?: string;
  animate?: boolean;
}

const OCLoadingMessage = styled("span")(({ theme }) => ({
  "@keyframes ellipsis": {
    "0%": { opacity: 0 },
    "50%": { opacity: 1 },
    "100%": { opacity: 0 },
  },
  "&.animation": {
    "& span": {
      opacity: 0,
      animation: "dot 1s infinite",
      animationName: "$ellipsis",
    },
    "& span:nth-of-type(1n)": {
      animationDelay: "0s",
    },
    "& span:nth-of-type(2n)": {
      animationDelay: "0.1s",
    },
    "& span:nth-of-type(3n)": {
      animationDelay: "0.2s",
    },
  },
}));

export const LoadingMessage = (props: ILoadingMessageProps): JSX.Element => {
  const { message, animate } = props;
  return (
    <OCLoadingMessage className={classNames(animate !== false && "animation")}>
      {!!message && message} <span>.</span>
      <span>.</span>
      <span>.</span>
    </OCLoadingMessage>
  );
};
